<div class="form-group switch-container" [ngClass]="customClass">
  <label for="" class="form-label">
    {{label}}
    @if (labelDesc) {
      <span class="switch-desc">{{labelDesc}}</span>
    }
  </label>
  <div class="md-switch">
    <input type="checkbox"
      #switchBtn
      [disabled]="disableBtn"
      id="switch-{{labelEn}}-{{index}}"
      [(ngModel)]="value"
      [checked]="value"
      (change)="changeValue($event.target)"
      name="switch-{{labelEn}}-{{index}}"
      class="md-toggle md-toggle-round">
      <label for="switch-{{labelEn}}-{{index}}"></label>
    </div>
  </div>
